import type { Pagination } from '@app/pages/Warehouses/Products/types';

export const getRange = ({ ItemsPerPage, Total, PageN }: Pagination) => {
  if (ItemsPerPage <= 0 || Total <= 0 || PageN <= 0) {
    return { from: 0, to: 0 };
  }
  const from = (PageN - 1) * ItemsPerPage + 1;
  const to = Math.min(PageN * ItemsPerPage, Total);

  return { from, to };
};
